import { render, staticRenderFns } from "./model_8.vue?vue&type=template&id=2a00c58c&scoped=true"
import script from "./model_8.vue?vue&type=script&lang=js"
export * from "./model_8.vue?vue&type=script&lang=js"
import style0 from "./model_8.vue?vue&type=style&index=0&id=2a00c58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a00c58c",
  null
  
)

export default component.exports